export default function Blog() {
  const articles = [
    {
      date: 'March 15, 2024',
      category: 'Industry Insights',
      title: 'The Future of BPO: Trends Shaping 2024',
      excerpt: 'Discover the latest trends in business process outsourcing and how they can transform your operations for maximum efficiency and growth.',
      image: 'https://public.readdy.ai/ai/img_res/ac02086882c45b8680d664451653b35c.jpg',
      link: '/bpo-blog'
    },
    {
      date: 'March 10, 2024',
      category: 'Best Practices',
      title: 'How to Choose the Right BPO Partner',
      excerpt: 'A comprehensive guide to selecting a BPO provider that aligns with your business goals and delivers measurable results.',
      image: 'https://readdy.ai/api/search-image?query=Business%20partnership%20handshake%20professional%20meeting%20modern%20office%20setting%20corporate%20collaboration%20team%20discussion%20strategy%20planning%20clean%20professional%20environment%20natural%20lighting&width=600&height=400&seq=blog-choose-partner&orientation=landscape',
      link: '/bpo-blog'
    },
    {
      date: 'March 5, 2024',
      category: 'Case Study',
      title: 'Success Story: 300% ROI in 6 Months',
      excerpt: 'Learn how one company achieved remarkable growth by partnering with Call Center Pros for their customer service operations.',
      image: 'https://readdy.ai/api/search-image?query=Business%20success%20growth%20chart%20upward%20trend%20financial%20performance%20metrics%20dashboard%20analytics%20visualization%20modern%20corporate%20office%20professional%20setting%20clean%20design%20blue%20accents&width=600&height=400&seq=blog-success-story&orientation=landscape',
      link: '/bpo-blog'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-full px-4 py-2 mb-4">
            <span className="text-sm font-medium text-blue-700">Latest Insights</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            From Our Blog
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest trends, insights, and best practices in BPO and customer service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <article
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <i className="ri-calendar-line"></i>
                  <time>{article.date}</time>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {article.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                
                <a
                  href={article.link}
                  className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold transition-colors"
                >
                  Read More
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/bpo-blog"
            className="inline-flex items-center gap-2 bg-white border-2 border-gray-300 hover:border-blue-600 hover:text-blue-600 text-gray-700 px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap shadow-sm"
          >
            View All Articles
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}